export function IntroCard({ image, title, content }) {
  return (
    <div className="p-4 flex mx-10 flex-col items-center w-full md:w-1/2 lg:w-1/4">
      <div className="rounded-full overflow-hidden">
        <img className="w-full h-full object-cover" src={image} alt="" />
      </div>
      <div className="text-center mx-auto">
        <h2 className="my-5">{title}</h2>
        <p className="text-white text-left mt-2">{content}</p>
      </div>
    </div>
  );
}
